import ListItem from '@tiptap/extension-list-item';
import type { List as ListType } from '../data/.types/lists.ts';
import { AutoColourMarkersPlugin } from './autoColourMarkersPlugin.ts';

const CustomListItem = (listConfig: ListType) => {
  return ListItem.extend({
    addProseMirrorPlugins() {
      const plugins = this.parent?.() || [];

      return [...plugins, AutoColourMarkersPlugin(listConfig)];
    },
    addAttributes() {
      return {
        ...this.parent?.(),
        style: {
          default: () => null,
          parseHTML: (element) => element.getAttribute('style'),
          renderHTML: (attributes) => {
            if (!attributes.style) {
              return {};
            }
            return { style: attributes.style };
          },
        },
      };
    },
  });
};

export default CustomListItem;
